import React from 'react';
import { PageSection } from '@gik/ui';
import { SituationsOverviewGrid } from '.';
import bemBlock from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

export const SituationsOverviewSectionBlockName = 'situations-overview-section';

export default function SituationsOverviewSection(): React.ReactElement {
  const bem = bemBlock(SituationsOverviewSectionBlockName);
  const { t } = useTranslation();

  return (
    <PageSection variant="solid-neutral" className={bem(null, null, 'gik-article')}>
      <h2 className={bem('title')}>{t(translationKeys.title)}</h2>
      <SituationsOverviewGrid />
      <p className={bem('lead')}>{t(translationKeys.leadText)}</p>
    </PageSection>
  );
}
